export default "__VITE_ASSET__BCzEEffW__"